import Vue from 'vue'
import App from './App.vue'
import router from './router'
import less from 'less'
 
Vue.config.productionTip = false //消息提示的环境配置，设置为开发环境或者生产环境,当前为开发模式
Vue.use(less)
 
// 4. 创建和挂载根实例。
new Vue({
	router,//通过 router 配置参数注入路由， 从而让整个应用都有路由功能
	render: h => h(App),
}).$mount('#app')